import React from "react";
import NoDiasMessage from "./NoDiasMessage";
import EditDiaContainer from "../../../containers/settings/slideshow/EditDiaContainer";
import Dia from "./Dia";
import { languages } from "../../../constants/languages";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import SlideshowsContainer from "../../../containers/settings/slideshow/SlideshowsContainer";
// import maxTeamsDressingRooms from "../../../constants/MaxTeamsDressingRooms";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import FontSizeContainer from "../../../containers/settings/slideshow/FontSizeContainer";
import NumRowsPerFontSize from "../../../constants/NumRowsPerFontSize";
import InfoIcon from "@material-ui/icons/Info";

const Settings = (props) =>
  props.dias.length > 0 || props.selectedSlideshow !== "0" ? (
    <div style={{ width: "100%", paddingTop: 50 }}>
      <div
        style={{
          width: 650,
          maxWidth: "97%",
          margin: "auto",
          marginBottom: 20,
        }}
      >
        <Typography variant="h6">{languages.tournament.slideShow}</Typography>
        <Typography variant="caption">
          {languages.tournament.diaPresentationDescription}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={
                props.tournament.showTournamentName ||
                props.tournament.showTournamentName === undefined
                  ? true
                  : false
              }
              onChange={props.handleShowChange}
              color="primary"
              name="showTournamentName"
            />
          }
          label={languages.tournament.showTournamentName}
        />
        <br />
        <FormControlLabel
          control={
            <Switch
              checked={
                props.tournament.showLiveTime !== undefined
                  ? props.tournament.showLiveTime
                  : props.tournament.vrsn >= 2
                  ? true
                  : false
              }
              onChange={props.handleShowChange}
              color="primary"
              name="showLiveTime"
            />
          }
          label={languages.tournament.showLiveTime}
        />

        {!props.tournament.liveLink && (
          <div style={{ margin: "15px 0px 20px 0px" }}>
            <Typography
              variant="body2"
              style={{
                background: "rgb(236, 239, 241)",
                padding: 10,
                borderRadius: 5,
                width: "100%",
              }}
            >
              <InfoIcon
                style={{
                  height: 15,
                  width: 15,
                  marginRight: 3,
                  top: 2,
                  position: "relative",
                }}
              />

              {languages.tournament.noLiveLink}
            </Typography>
          </div>
        )}
      </div>
      <div
        style={{
          width: 650,
          maxWidth: "97%",
          margin: "auto",
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <SlideshowsContainer
          tournament={props.tournament}
          slideshows={props.slideshows}
          slideshowsByKey={props.slideshowsByKey}
          selectSlideshow={props.selectSlideshow}
          selectedSlideshow={props.selectedSlideshow}
          handleAddSlideshow={props.handleAddSlideshow}
          dias={props.dias}
          allDias={props.allDias}
        />
        <FontSizeContainer
          tournament={props.tournament}
          slideshowsByKey={props.slideshowsByKey}
          selectedSlideshow={props.selectedSlideshow}
        />
      </div>
      <div
        style={{
          width: 650,
          maxWidth: "97%",
          margin: "auto",
          marginBottom: 20,
        }}
      >
        <DragDropContext onDragEnd={props.onDragEnd}>
          <Droppable droppableId="diaDrop">
            {(provided, snapshot) => {
              return (
                <div ref={provided.innerRef}>
                  {props.dias.map((dia, i) => {
                    let dressingRoomElements = [];
                    let teamLayoutElements = [];
                    let rankingElements = [];
                    let playerStatsElements = [];
                    const playerPoints =
                      props.tournament.playerPoints || {};
                    const statEntries = Object.keys(playerPoints)
                      .map((key) => ({
                        key: key,
                        ...playerPoints[key],
                      }))
                      .filter((p) => p.type !== "3");
                    let fontSize =
                      (props.slideshowsByKey[props.selectedSlideshow] || {})
                        .slideshowFontSize || "1";
                    if (props.selectedSlideshow === "0") {
                      fontSize = props.tournament.slideshowFontSize || "1";
                    }
                    let maxTeamsDressingRooms =
                      NumRowsPerFontSize[Number(fontSize)];
                    props.divisions.forEach((division) => {
                      let teams = props.teams.filter(
                        (t) => t.division === division.id
                      );
                      let players = props.players.filter(
                        (t) =>
                          (props.teamsByKey[t.team] || {}).division ===
                          division.id
                      );
                      let numDressingRoomLayouts = Math.ceil(
                        teams.length / maxTeamsDressingRooms
                      );
                      let numTeamLayouts = Math.ceil(
                        players.length / maxTeamsDressingRooms
                      );
                      let numRankings = Math.ceil(
                        (props.ranking[division.id] || []).length /
                          maxTeamsDressingRooms
                      );
                      for (let i = 0; i < numDressingRoomLayouts; i++) {
                        let diaDressingRoomIndex =
                          dia[
                            "diaDressingRoomIndex" +
                              (division.id === "0"
                                ? i.toString()
                                : division.id + i.toString())
                          ];
                        if (
                          diaDressingRoomIndex !== null &&
                          diaDressingRoomIndex !== undefined
                        ) {
                          dressingRoomElements.push({
                            numInDia: diaDressingRoomIndex,
                            width:
                              dia[
                                "widthDiaDressingRooms" +
                                  (division.id === "0"
                                    ? i.toString()
                                    : division.id + i.toString())
                              ] || "1",
                            isDressingRooms: true,
                            divisionId: division.id,
                            layoutNum: i,
                            label:
                              languages.teams.dressingRoomLayout +
                              (props.divisions.length > 1
                                ? " - " + division.name
                                : "") +
                              (Math.ceil(teams.length / maxTeamsDressingRooms) >
                              1
                                ? " (" +
                                  (Number(i) + 1).toString() +
                                  "/" +
                                  Math.ceil(
                                    teams.length / maxTeamsDressingRooms
                                  ).toString() +
                                  ")"
                                : ""),
                            id: "dressingRooms" + division.id + i.toString(),
                          });
                        }
                      }
                      for (let i = 0; i < numTeamLayouts; i++) {
                        let teamLayoutsIndex =
                          dia[
                            "diaTeamLayoutIndex" +
                              (division.id === "0"
                                ? i.toString()
                                : division.id + i.toString())
                          ];
                        if (
                          teamLayoutsIndex !== null &&
                          teamLayoutsIndex !== undefined
                        ) {
                          teamLayoutElements.push({
                            numInDia: teamLayoutsIndex,
                            width:
                              dia[
                                "widthDiaTeamLayouts" +
                                  (division.id === "0"
                                    ? i.toString()
                                    : division.id + i.toString())
                              ] || "0",
                            isTeamLayouts: true,
                            divisionId: division.id,
                            layoutNum: i,
                            label:
                              languages.teams.squadList +
                              (props.divisions.length > 1
                                ? " - " + division.name
                                : "") +
                              (Math.ceil(
                                players.length / maxTeamsDressingRooms
                              ) > 1
                                ? " (" +
                                  (Number(i) + 1).toString() +
                                  "/" +
                                  Math.ceil(
                                    players.length / maxTeamsDressingRooms
                                  ).toString() +
                                  ")"
                                : ""),
                            id: "teamLayouts" + division.id + i.toString(),
                          });
                        }
                      }
                      for (let i = 0; i < numRankings; i++) {
                        let diaRankingIndex =
                          dia["diaRankingIndex" + division.id + i.toString()];
                        if (
                          diaRankingIndex !== null &&
                          diaRankingIndex !== undefined
                        ) {
                          rankingElements.push({
                            numInDia: diaRankingIndex,
                            width:
                              dia[
                                "widthDiaRanking" + division.id + i.toString()
                              ] || "1",
                            isRanking: true,
                            rankingNum: i,
                            divisionId: division.id,
                            label:
                              languages.results.ranking +
                              (props.divisions.length > 1
                                ? " - " + division.name
                                : "") +
                              (numRankings > 1
                                ? " (" +
                                  (Number(i) + 1).toString() +
                                  "/" +
                                  numRankings.toString() +
                                  ")"
                                : ""),
                            id: "ranking" + division.id + i,
                          });
                        }
                      }
                      statEntries.forEach((stat) => {
                        const indexKey =
                          "diaPlayerStatsIndex" +
                          division.id +
                          "_" +
                          stat.key;
                        const widthKey =
                          "widthDiaPlayerStats" +
                          division.id +
                          "_" +
                          stat.key;
                        const indexValue = dia[indexKey];
                        if (indexValue !== null && indexValue !== undefined) {
                          const statLabel = stat.name || stat.abbr || "";
                          playerStatsElements.push({
                            numInDia: indexValue,
                            width: dia[widthKey] || "3",
                            isPlayerStats: true,
                            statKey: stat.key,
                            divisionId: division.id,
                            label:
                              statLabel +
                              (props.divisions.length > 1
                                ? " - " + division.name
                                : "") +
                              " (" +
                              languages.formatString(
                                languages.present.topN,
                                maxTeamsDressingRooms
                              ) +
                              ")",
                            id:
                              "playerStats" + division.id + "_" + stat.key,
                          });
                        }
                      });
                    });
                    let upcomingMatchesElements = [];
                    let recentResultsElements = [];
                    props.sportParks.forEach((sportPark) => {
                      // upcoming
                      let diaUpcomingMatchesIndex =
                        dia["diaUpcomingMatchesIndex" + sportPark.id];
                      if (
                        diaUpcomingMatchesIndex !== null &&
                        diaUpcomingMatchesIndex !== undefined
                      ) {
                        upcomingMatchesElements.push({
                          numInDia: diaUpcomingMatchesIndex,
                          width:
                            dia["widthDiaUpcomingMatches" + sportPark.id] ||
                            "3",
                          isUpcomingMatches: true,
                          sportParkId: sportPark.id,
                          label:
                            languages.schedule.upcomingMatches +
                            (props.sportParks.length > 1 &&
                            !props.tournament.online
                              ? " (" + sportPark.name + ")"
                              : ""),
                          id: "upcomingMatches" + sportPark.id,
                        });
                      }

                      // recent results
                      let diaRecentResultsIndex =
                        dia["diaRecentResultsIndex" + sportPark.id];
                      if (
                        diaRecentResultsIndex !== null &&
                        diaRecentResultsIndex !== undefined
                      ) {
                        recentResultsElements.push({
                          numInDia: diaRecentResultsIndex,
                          width:
                            dia["widthDiaRecentResults" + sportPark.id] || "3",
                          isRecentResults: true,
                          sportParkId: sportPark.id,
                          label:
                            languages.schedule.recentResults +
                            (props.sportParks.length > 1 &&
                            !props.tournament.online
                              ? " (" + sportPark.name + ")"
                              : ""),
                          id: "recentResults" + sportPark.id,
                        });
                      }
                    });

                    let photoElements = [];
                    let sponsorElements = [];
                    let textElements = [];
                    ["", "1", "2", "3", "4", "5", "6", "7", "8"].forEach(
                      (x) => {
                        if (
                          dia["diaPhotoIndex" + x] !== null &&
                          dia["diaPhotoIndex" + x] !== undefined
                        ) {
                          photoElements.push({
                            numInDia: dia["diaPhotoIndex" + x],
                            width: dia["widthDiaPhoto" + x] || "3",
                            isPicture: true,
                            photoNum: x,
                            label:
                              languages.present.picture +
                              (dia["diaPhotoTitle" + x]
                                ? " - " + dia["diaPhotoTitle" + x]
                                : ""),
                            id: "picture" + x,
                            photoURL: dia["diaPhotoURL" + x],
                            photoTitle: dia["diaPhotoTitle" + x],
                          });
                        }

                        if (
                          dia["sponsorIndex" + x] !== null &&
                          dia["sponsorIndex" + x] !== undefined
                        ) {
                          sponsorElements.push({
                            numInDia: dia["sponsorIndex" + x],
                            isSponsors: true,
                            sponsorNum: x,
                            label: languages.present.sponsors,
                            id: "sponsors" + x,
                            // sponsorGroup: dia["sponsorGroup" + x] || null,
                          });
                        }

                        if (
                          dia["diaTextIndex" + x] !== null &&
                          dia["diaTextIndex" + x] !== undefined
                        ) {
                          textElements.push({
                            numInDia: dia["diaTextIndex" + x],
                            width: dia["widthDiaText" + x] || "3",
                            isText: true,
                            textNum: x,
                            label:
                              languages.present.text +
                              (dia["diaTextTitle" + x]
                                ? " - " + dia["diaTextTitle" + x]
                                : ""),
                            id: "text" + x,
                            textTitle: dia["diaTextTitle" + x],
                            text: dia["diaText" + x],
                          });
                        }
                      }
                    );
                    return (
                      <Draggable key={dia.id} draggableId={dia.id} index={i}>
                        {(provided, snapshot) => (
                          <div>
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className="dia"
                            >
                              <Dia
                                provided={provided}
                                user={props.user}
                                userData={props.userData}
                                userStatus={props.userStatus}
                                tournamentStatus={props.tournamentStatus}
                                dia={dia}
                                num={i}
                                tournament={props.tournament}
                                dias={props.dias}
                                structureElements={(
                                  props.structureElementsPerDia[dia.id] || []
                                )
                                  .concat(
                                    sponsorElements
                                    // dia.sponsorIndex !== null
                                    //   ? [
                                    //       {
                                    //         numInDia: dia.sponsorIndex,
                                    //         isSponsors: true,
                                    //         label: languages.present.sponsors,
                                    //         id: "sponsors",
                                    //       },
                                    //     ]
                                    //   : []
                                  )
                                  .concat(textElements)
                                  .concat(photoElements)
                                  .concat(
                                    dia.qrCodeIndex !== null &&
                                      dia.qrCodeIndex !== undefined
                                      ? [
                                          {
                                            numInDia: dia.qrCodeIndex,
                                            width: dia["widthQRCode"] || "1",
                                            isQRCode: true,
                                            label: languages.tournament.qrCode,
                                            id: "qrCode",
                                          },
                                        ]
                                      : []
                                  )
                                  .concat(dressingRoomElements)
                                  .concat(teamLayoutElements)
                                  .concat(upcomingMatchesElements)
                                  .concat(recentResultsElements)
                                  .concat(rankingElements)
                                  .concat(playerStatsElements)
                                  .sort(
                                    (a, b) =>
                                      (a.numInDiaLocal !== undefined
                                        ? a.numInDiaLocal
                                        : a.numInDia) -
                                      (b.numInDiaLocal !== undefined
                                        ? b.numInDiaLocal
                                        : b.numInDia)
                                  )}
                                structureElementsNotDivided={
                                  props.structureElementsNotDivided
                                }
                                handleAddSponsors={props.handleAddSponsors}
                                handleActiveCheck={props.handleActiveCheck}
                                days={props.days}
                                daysByKey={props.daysByKey}
                                teams={props.teams}
                                teamsByKey={props.teamsByKey}
                                players={props.players}
                                divisions={props.divisions}
                                sportParks={props.sportParks}
                                slideshowsByKey={props.slideshowsByKey}
                                selectedSlideshow={props.selectedSlideshow}
                                ranking={props.ranking}
                                isDraggingWithinDia={props.isDraggingWithinDia}
                                setDraggingWithinDia={
                                  props.setDraggingWithinDia
                                }
                                diasByKey={props.diasByKey}
                                handleAddQRCode={props.handleAddQRCode}
                                handleTeamLayoutsSortChange={
                                  props.handleTeamLayoutsSortChange
                                }
                              />
                            </div>
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
        <EditDiaContainer
          tournament={props.tournament}
          dias={props.dias}
          selectedSlideshow={props.selectedSlideshow}
          days={props.days}
          daysByKey={props.daysByKey}
        />
      </div>
    </div>
  ) : (
    <NoDiasMessage
      tournament={props.tournament}
      dias={props.dias}
      selectedSlideshow={props.selectedSlideshow}
    />
  );

export default Settings;
